export const RESET_PASSWORD: string = 'reset-password';
export const NEWSLETTER_ACTION_WITH_VOUCHER: string = 'sub';
export const NEWSLETTER_ACTION_WITHOUT_VOUCHER: string = 'transferred';
export const VERIFY_EMAIL: string = 'verify-email';
// The browser allows only 6 connections per host; CIA calls are mostly fire-and-forget, so a slow CIA
// upstream must not hold those connections for long, or it blocks the requests a page navigation needs.
export const CIA_REQUEST_TIMEOUT: number = 5000; // milliseconds
